import * as React from 'react';

export default class HeaderTaskBar extends React.Component{

    render(){
        return(
            <div className="ms-Grid-row topTool task-bar">
                {this.props.children}
            </div>
        )
    }
}